import { COUNTER } from '../constants/actionTypes'

const uploadActions = (counter = {}, action) => {
    switch (action.type) {
        case COUNTER:
            return action.payload;
        default:
            return counter;
    }
}

export default uploadActions